import {
  Checkbox,
  FormControl,
  FormLabel,
  Heading,
  Select,
  SimpleGrid,
  Stack,
} from '@chakra-ui/react'
import { map } from 'lodash'
import useCurrentReport from '../../../../hooks/useCurrentReport'
import { waterTypes } from '../../../../store/useStore'
import ValidatedInput from '../../../../components/ValidatedInput'
import useUpdateReportDoc from '../../../../hooks/useUpdateReportDoc'

const WaterQuestions = () => {
  const updateReport = useUpdateReportDoc()
  const report = useCurrentReport()

  const handleInputChange = (field: string, value: any) => {
    updateReport({ [field]: value })
  }

  return (
    <Stack>
      <Heading size='md'>Water Questions</Heading>
      <Checkbox
        isChecked={!!report?.waterConfirmed}
        onChange={(e) => handleInputChange('waterConfirmed', e.target.checked)}
        pl={5}
      >
        The source and amount of water I drank on a typical day is below.
      </Checkbox>
      <FormControl isRequired>
        <SimpleGrid columns={[1, 2]}>
          <FormLabel pl={5}>What kind of water are you drinking?</FormLabel>
          <Select
            placeholder='Choose Type'
            onChange={(e) => {
              handleInputChange(
                'waterType',
                e.target.value as keyof typeof waterTypes,
              )
            }}
            value={report?.waterType || ''}
          >
            {map(waterTypes, (label, id) => {
              return (
                <option value={id} key={id}>
                  {label}
                </option>
              )
            })}
          </Select>
        </SimpleGrid>
      </FormControl>
      <ValidatedInput
        label='How many ounces (oz) of water do you drink on average per day? (1 oz = 30mL)'
        value={report?.waterAmount ?? null}
        min={0}
        max={200}
        isRequired={true}
        onChange={(value) => handleInputChange('waterAmount', value)}
        pl={5}
      />
    </Stack>
  )
}

export default WaterQuestions
